import { useEffect, useRef } from 'react';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const FunctionalityElipsis = ({
    useRef,
    ellipsis,
    selectedShapeId,
    useEffect,
    handleDragMove,
    setShapeRadius,
    setStageProperties,
    currentStage,
    index,
}) => {
    const shapeRef = useRef(null);
    const trRef = useRef(null);
    const isSelected = ellipsis.id === selectedShapeId;
    const MAX_RADIUS = 305;
    // If this shape is selected, attach the transformer to it
    useEffect(() => {
        if (selectedShapeId === ellipsis.id) {
            trRef.current.nodes([shapeRef.current]);
            trRef.current.getLayer().batchDraw();
        }
    }, [selectedShapeId, ellipsis.id]);
    // Restrict shape movement within stage boundaries while dragging
    const handleDragMoveWithLimit = (e, index) => {
        const shape = e.target;
        const radius = shape.radius();
        const stage = shape.getStage();
        const width = stage.width();
        const height = stage.height();
        let x = shape.x();
        let y = shape.y();
        x = Math.round(x);
        y = Math.round(y);
        // Prevent the shape from going out of bounds
        if (x - radius < 0) x = radius;
        if (x + radius > width) x = width - radius;
        if (y - radius < 0) y = radius;
        if (y + radius > height) y = height - radius;

        shape.x(x);
        shape.y(y);

        handleDragMove(e, index);
    };
    // Handle transform (resize) end
    const handleTransformEnd = (e) => {
        e.preventDefault();
        const node = shapeRef.current;
        const stage = node.getStage();
        const currentRadius = node.radius();
        const newRadius = Math.max(node.radius() * node.scaleX(), node.radius() * node.scaleY());
        // Calculate maximum possible radius within stage bounds
        let x = node.x();
        let y = node.y();
        const maxRadiusX = Math.min(x, stage.width() - x);
        const maxRadiusY = Math.min(y, stage.height() - y);
        const maxRadius = Math.min(maxRadiusX, maxRadiusY);
        const finalRadius = Math.min(newRadius, maxRadius);
        node.scaleX(1);
        node.scaleY(1);

        setShapeRadius(finalRadius);
        setStageProperties((prevProperties) => {
            const currentProperties = prevProperties[currentStage];
            const updatedEllipsis = [...currentProperties.combinedObject];
            updatedEllipsis[index] = {
                ...updatedEllipsis[index],
                radius: finalRadius,
                x: node.x(),
                y: node.y(),
                rotation: node.rotation(),
            };

            return {
                ...prevProperties,
                [currentStage]: {
                    ...currentProperties,
                    combinedObject: updatedEllipsis,
                },
            };
        });
    };

    return {
        shapeRef,
        isSelected,
        handleDragMoveWithLimit,
        handleTransformEnd,
        trRef,
        MAX_RADIUS,
    };
};
export default FunctionalityElipsis;
